import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { IEditCredentialsContext, EditCredentialsContext } from '../../editCredentialsState/editCredentialsContext';
import {
	IWithAdditionalValidationContext,
	WithAdditionalValidationContext,
} from 'components/WithAdditionalValidation/withAdditionalValidationContext';
import { CredentialName } from './components/CredentialName';
import { ApiKey } from './components/ApiKey';
import { ApiSecret } from './components/ApiSecret';
import { BtnBlock } from './components/BtnBlock';
import { Form } from 'antd';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './EditForm.module.scss';

export const EditForm: React.FC = () => {
	const { setMainFormValidationFail, additionalValidationErrors } = useContext<IWithAdditionalValidationContext>(
		WithAdditionalValidationContext,
	);

	const {
		changeTypeOfModalWindow,
		setDataForSubmit,
		changeCredentialName,
		changeApiKey,
		changeApiSecret,
		initialFormData,
		credentialID,
		credentialType,
		credentialName,
		apiKey,
		apiSecret,
	} = useContext<IEditCredentialsContext>(EditCredentialsContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ credentialName, apiKey, apiSecret });
	}, [credentialName, apiKey, apiSecret]);

	const submit = () => {
		setMainFormValidationFail(false);
		setDataForSubmit({
			type: credentialType, // type must be the first property in the payload
			id: credentialID,
			name: credentialName,
			apiKey,
			apiSecret,
			isSecretUpdated: initialFormData?.apiSecret !== apiSecret,
		});
		additionalValidationErrors.length
			? setMainFormValidationFail(true)
			: changeTypeOfModalWindow('toConfirmSubmit');
	};

	const handleFormValidationFail = () => {
		setMainFormValidationFail(true);
	};

	return (
		<div className={style.container} data-test="CreationForm">
			<div className={style.formWrapper}>
				<Form
					form={form}
					name="basic"
					onFinish={submit}
					onKeyPress={preventDefaultForEnterKey}
					onFinishFailed={handleFormValidationFail}
					layout="vertical">
					<div className={style.fieldsWrapper}>
						<Text
							translationNameSpace="form"
							translationKey="mainInfoHeading"
							theme="secondary"
							size="l"
							weight="bold"
							display="inline"
						/>
						<CredentialName onChange={changeCredentialName} />
						<div className={style.row}>
							<ApiKey onChange={changeApiKey} />
							<ApiSecret onChange={changeApiSecret} />
						</div>
					</div>
					<BtnBlock />
				</Form>
			</div>
		</div>
	);
};
